import { ERenderPreset } from '@/commons/renderPresetToggleList/typescript/ERenderPreset';
import type { IPreset } from '@/commons/renderPresetToggleList/typescript/IPreset';

const renderPreset: Record<ERenderPreset, IPreset> = {
    default: {
        sun: {
            color: {
                r: 252,
                g: 187,
                b: 165,
            },
            position: {
                x: 1,
                y: 1.6,
                z: 0,
            },
            power: 7,
            distance: 5.7,
            shadow: {
                near: 0.6,
                far: 1.4,
            },
        },
        shadow: {
            color: {
                r: 255,
                g: 243,
                b: 227,
            },
            power: 1.5,
        },
        ambient: {
            color: {
                r: 249,
                g: 252,
                b: 246,
            },
            power: 6.5,
        },
        bgColor: {
            r: 185,
            g: 185,
            b: 185,
        },
        envMap: {
            name: 'Snowy Hillside',
            envAsBg: false,
        },
    },
    luxury: {
        sun: {
            color: {
                r: 252,
                g: 187,
                b: 165,
            },
            position: {
                x: -0.4,
                y: 1,
                z: -0.4,
            },
            power: 20,
            distance: 5.7,
            shadow: {
                near: 0.6,
                far: 1.39,
            },
        },
        shadow: {
            color: {
                r: 255,
                g: 243,
                b: 227,
            },
            power: 2,
        },
        ambient: {
            color: {
                r: 211,
                g: 200,
                b: 162,
            },
            power: 1.25,
        },
        bgColor: {
            r: 21,
            g: 22,
            b: 23,
        },
        envMap: {
            name: 'Indoor',
            envAsBg: false,
        },
    },
    sea: {
        sun: {
            color: {
                r: 107,
                g: 28,
                b: 1,
            },
            position: {
                x: 6,
                y: 0.6,
                z: 4.4,
            },
            power: 100,
            distance: 12.2,
            shadow: {
                near: 1.64,
                far: 1.48,
            },
        },
        shadow: {
            color: {
                r: 7,
                g: 11,
                b: 80,
            },
            power: 2,
        },
        ambient: {
            color: {
                r: 242,
                g: 114,
                b: 231,
            },
            power: 1.7,
        },
        bgColor: {
            r: 179,
            g: 145,
            b: 179,
        },
        envMap: {
            name: 'Venice Sunset',
            envAsBg: false,
        },
    },
    modern: {
        sun: {
            color: {
                r: 217,
                g: 192,
                b: 84,
            },
            position: {
                x: -3.6,
                y: 4,
                z: -6.7,
            },
            power: 1850,
            distance: 12.2,
            shadow: {
                near: 1.64,
                far: 1.48,
            },
        },
        shadow: {
            color: {
                r: 107,
                g: 99,
                b: 144,
            },
            power: 20,
        },
        ambient: {
            color: {
                r: 242,
                g: 149,
                b: 114,
            },
            power: 2,
        },
        bgColor: {
            r: 236,
            g: 192,
            b: 167,
        },
        envMap: {
            name: 'Modern Buildings',
            envAsBg: false,
        },
    },
    meadow: {
        sun: {
            color: {
                r: 201,
                g: 200,
                b: 162,
            },
            position: {
                x: -1,
                y: 2,
                z: 0.5,
            },
            power: 90,
            distance: 12.2,
            shadow: {
                near: 0.5,
                far: 1.5,
            },
        },
        shadow: {
            color: {
                r: 70,
                g: 141,
                b: 119,
            },
            power: 1,
        },
        ambient: {
            color: {
                r: 255,
                g: 212,
                b: 226,
            },
            power: 1.25,
        },
        bgColor: {
            r: 140,
            g: 166,
            b: 138,
        },
        envMap: {
            name: 'Meadow 2',
            envAsBg: false,
        },
    },
    snowy: {
        sun: {
            color: {
                r: 0,
                g: 153,
                b: 230,
            },
            position: {
                x: 0,
                y: -5,
                z: -1.5,
            },
            power: 500,
            distance: 6.6,
            shadow: {
                near: 0.5,
                far: 1.5,
            },
        },
        shadow: {
            color: {
                r: 211,
                g: 102,
                b: 189,
            },
            power: 10,
        },
        ambient: {
            color: {
                r: 115,
                g: 232,
                b: 255,
            },
            power: 1,
        },
        bgColor: {
            r: 138,
            g: 161,
            b: 178,
        },
        envMap: {
            name: 'Snowy Hillside',
            envAsBg: false,
        },
    },
};

export { renderPreset };
